import { EmployeeTransport, TransportationType } from "../types/ganttChart";

// Resolve which transportation type is active at a given timestamp. Segments
// are half-open intervals [start, end). Single-mode shifts have exactly one
// segment so the helper degenerates to that one element.
//
// The cast is safe on the read path: `EmployeeTransport.transportationType` is
// typed `TransportationType | ""` only to accommodate the drawer's in-progress
// editing buffer. Server-originated segments (the only ones the read sites
// see) always carry a concrete `TransportationType`.
export const transportTypeAt = (
  segments: EmployeeTransport[],
  time: string,
): TransportationType => {
  const found = segments.find(
    (segment) => segment.start <= time && time < segment.end,
  );
  return (found ?? segments[0]).transportationType as TransportationType;
};
